<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <template>
              <v-toolbar card color="white">
                <v-toolbar-title class="indigo--text"
                  >Información de Pagos y Multas</v-toolbar-title
                >
              </v-toolbar>
              <pagos-multas :tabse="'Pagos'"></pagos-multas>
            </template>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import PagosMultas from "@/modules/configuration/pagosymultas/views/PagosMultas.vue";

export default {
  name: "pagos-multas-select",

  components: {
    PagosMultas,
  },

  props: {},

  data() {
    return {
      text: "En construccion",
      id: "",
    };
  },

  mounted() {},
  created() {
    this.id = this.$route.params.id;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proSelectedStored = this.$store.getters.proSelectedStored;
  },

  methods: {},
};
</script>
